module.exports = __webpack_public_path__ + "static/media/banner.5b0915cc.jpg";